export interface CardData {
  cardDetails: CardDetails;
}

export interface CardDetails {
  paymentCardNum: string;
}

export interface ActiveCard {
  paymentCardNum: string;
  cardType: string;
  secureTransactionInd: boolean;
}

export interface PaymentReference {
  paymentReferenceId: string;
  activeCard?: ActiveCard;
}
